module.exports = __webpack_public_path__ + "img/c01_unitballista_Normal_ua.be1a4b3d.webp";